import WashingtonStateTaxDisclaimer from "./WashingtonStateTaxDisclaimer";

export default WashingtonStateTaxDisclaimer;



// WEBPACK FOOTER //
// ./src/apps/payment/components/WashingtonStateTaxDisclaimer/index.js